import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Стандартный helper для композиции Tailwind-классов. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
